export default "__VITE_ASSET__FzyvdK5t__";